import React from 'react'

import { features } from '../SchoolCommunity.data'

export default function FeaturesSection() {
  return (
    <dl className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2 lg:grid-cols-4 mt-10 lg:mt-0">
      {features.map((feature) => (
        <div
          key={feature.name}
          className="py-6 px-8 rounded-3xl border border-zinc-700">
          <dt>
            <feature.icon />
            <p className="mt-8 text-xl font-medium leading-6 text-white">
              {feature.name}
            </p>
          </dt>
          <dd className="mt-2 text-base text-indigo-200">
            {feature.description}
          </dd>
        </div>
      ))}
    </dl>
  )
}
